export const extractImageSrc = (description) => {
  const imgRegex = /<img[^>]+src="([^">]+)"/g
  const imgMatch = imgRegex.exec(description)
  return imgMatch ? imgMatch[1] : null
}
